import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

@Injectable()

  // export class Dashb1Service {
  export class SensorsService {

    constructor(private _http: HttpClient) { }

    DeviceInfo(dev, gateway, apiToken: string){
     
      return this._http.post("https://api.cognition.world/v1/dash/sensor",{
        deveui: dev,
        gateway: gateway,
      }, {headers:{'Authorization': apiToken}})
        .map(result => result);
    }
  
    GetDevCSV(deveui: string, startDate: number, endDate: number, apiToken: string){
      
      return this._http.get("https://api.cognition.world/v1/dataextract/csv/" + deveui + '-' + startDate + '-' + endDate, {headers:{'Authorization': apiToken}})
        .map(result => result);
    }

    changeAsset(dev, action, value, clientId,username,apiToken){
      return this._http.post("https://api.cognition.world/v1/dash/sensor",{
        deveui: dev,
        action: action,
        clientId: clientId,
        username: username,
        value: value
      }, {headers:{'Authorization': apiToken}})
        .map(result => result);
    }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/sensors/sensors.service.ts